// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark .item-outer.mod-highlighted .item::before{background-color:#111}\n", ""]);
// Exports
module.exports = exports;
